export default "__VITE_ASSET__BaL7XuD0__"